import { Component, OnInit, Output, EventEmitter, Input, OnChanges, OnDestroy } from '@angular/core';
import * as countryData from 'country-data';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { CallingCountriesResponse, CountryCallingInfo } from './CountryCallingInfo';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'cc-phone-numbers-dropdown',
  templateUrl: './phone-numbers-dropdown.component.html',
  styleUrls: ['./phone-numbers-dropdown.component.scss']
})
export class PhoneNumbersDropdownComponent implements OnInit, OnChanges, OnDestroy {
  @Input() private initialCountryCode: string;
  @Output() change = new EventEmitter<CountryCallingInfo>();

  formControl: FormControl;
  countryFilter: FormControl = new FormControl();
  filteredNumbers: Observable<CountryCallingInfo[]>;

  currentNumber: CountryCallingInfo;
  private _onDestroy = new Subject<void>();
  private countries: CountryCallingInfo[];
  private detectAutomaticallyItem: CountryCallingInfo = {
    countryCode: '',
    phonePrefix: '',
    flagEmoji: '',
    countryName: 'LEAD_GENERATION.CREATOR.BUBBLE.PREFIX_PLACEHOLDER'
  };

  constructor() {
    this.countries = [this.detectAutomaticallyItem, ...this.mapCountryData(countryData.callingCountries.all)];
  }

  ngOnInit() {
    this.formControl = new FormControl();
    this.filteredNumbers = this.countryFilter.valueChanges.pipe(startWith(''), map(value => this.filter(value)));
    this.countryFilter.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      this.filter(this.countryFilter.value);
    });
  }

  ngOnChanges() {
    this.currentNumber = this.findInitialCountry();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  private mapCountryData(countriesResponse: CallingCountriesResponse[]): CountryCallingInfo[] {
    return countriesResponse.map(country => ({
      countryCode: country.alpha2,
      phonePrefix: country.countryCallingCodes[0],
      flagEmoji: country.emoji,
      countryName: country.name
    }));
  }

  private findInitialCountry(): CountryCallingInfo {
    return this.initialCountryCode
      ? this.countries.find(option => option.countryCode.toLowerCase() === this.initialCountryCode)
      : this.detectAutomaticallyItem;
  }

  filter(value: string | CountryCallingInfo) {
    if (this.isCountryCallingInfo(value)) {
      return;
    }
    const filterValue = value.toLowerCase();
    return this.countries.filter(option => option.countryName.toLowerCase().includes(filterValue));
  }

  onSelectionChanged() {
    this.change.emit(this.currentNumber);
  }

  isCountryCallingInfo(val: any): val is CountryCallingInfo {
    return typeof val === 'object' && 'countryName' in val;
  }
}
